/**
 * Light impression + click tracking for PLP editorial promo cards.
 * Pushes to dataLayer when present; otherwise dispatches a CustomEvent.
 */
const SEEN = new WeakSet();

function pushEvent(payload) {
  const detail = {
    event: payload.event,
    amada_promo_id: payload.id,
    amada_promo_slot: payload.slot,
    amada_promo_collection: payload.collection,
    amada_promo_device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(detail);
  document.dispatchEvent(new CustomEvent('amada:plp-promo', { detail }));
}

function observeCard(card) {
  if (!(card instanceof HTMLElement) || SEEN.has(card)) return;
  SEEN.add(card);

  const id = card.getAttribute('data-amada-promo-id') || '';
  const slot = card.getAttribute('data-amada-promo-slot') || '';
  const collection = card.getAttribute('data-amada-promo-collection') || '';

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) continue;
        pushEvent({ event: 'amada_plp_promo_impression', id, slot, collection });
        io.disconnect();
      }
    },
    { threshold: [0.45] }
  );
  io.observe(card);

  card.addEventListener(
    'click',
    () => {
      pushEvent({ event: 'amada_plp_promo_click', id, slot, collection });
    },
    { capture: true }
  );
}

window.amadaPlpPromoTrack = function amadaPlpPromoTrack(root) {
  const scope = root instanceof Element ? root : document;
  scope.querySelectorAll('[data-amada-promo-id]').forEach(observeCard);
};

document.addEventListener('DOMContentLoaded', () => {
  window.amadaPlpPromoTrack(document);
});
